<template>
  <div>
    <h2>多图层</h2>
    <h3>基本使用</h3>
    <demo>
      <vue-form :model="form" :layer="layer">
        <vue-form-line :cols="[{ span: 12, label: '商品名称', prop: '/form/name' }]">
          <el-input v-model="form.name" placeholder="请输入商品名称" />
          <el-input v-model="form.name" placeholder="请输入商品名称" />
          <el-input v-model="form.name" placeholder="请输入商品名称" />
        </vue-form-line>
      </vue-form>
      <div slot="description">
        <p>layer 的每一个对象都是一个图层</p>
      </div>
      <div slot="meta">
        <pre><code class="hljs hl-html"><span class="hljs-tag">&lt;vue-form :model=<span class="hljs-string">"form"</span> :layer=<span class="hljs-string">"layer"</span>&gt;
    &lt;vue-form-line :cols=<span class="hljs-string">"[{ span: 12, label: '商品名称', prop: '/form/name' }]"</span>&gt;
      &lt;el-input v-model=<span class="hljs-string">"form.name"</span> placeholder=<span class="hljs-string">"请输入商品名称"</span> /&gt;
    &lt;/vue-form-line&gt;
  &lt;/vue-form&gt;
  &lt;script&gt;
  export default <span class="hljs-attr">{
    data() {
      <span class="hljs-tag">return</span> {
        form: {
          name: ""
        },
        layer: [
          {
            data: [
              {
                prop: "/form/name",
                data: "商品名称不能为空"
              }
            ]
          },
          {
            data: [
              {
                prop: "/form/name",
                data: "商品的全称",
                target: 'why'
              }
            ]
          }
        ]
      }
    }
  }</span>
  &lt;/script&gt;</span></code></pre>
      </div>
    </demo>
    <h3>图层显示/隐藏</h3>
    <demo>
      <vue-form :model="form" :layer="layer">
        <vue-form-line :cols="[{ span: 12, label: '商品名称', prop: '/form/name' }]">
          <el-input v-model="form.name" placeholder="请输入商品名称" />
        </vue-form-line>
      </vue-form>
      <div slot="description">
        <p>图层作用于 prop 指定的元素</p>
      </div>
      <div slot="meta">
        <pre><code class="hljs hl-html"><span class="hljs-tag">&lt;vue-form :model=<span class="hljs-string">"form"</span> :layer=<span class="hljs-string">"layer"</span>&gt;
    &lt;vue-form-line :cols=<span class="hljs-string">"[{ span: 12, label: '商品名称', prop: '/form/name' }]"</span>&gt;
      &lt;el-input v-model=<span class="hljs-string">"form.name"</span> placeholder=<span class="hljs-string">"请输入商品名称"</span> /&gt;
    &lt;/vue-form-line&gt;
  &lt;/vue-form&gt;
  &lt;script&gt;
  export default <span class="hljs-attr">{
    data() {
      <span class="hljs-tag">return</span> {
        form: {
          name: ""
        },
        layer: [
          {
            data: [
              {
                prop: "/form/name",
                data: "商品名称不能为空"
              }
            ]
          },
          {
            data: [
              {
                prop: "/form/name",
                data: "商品的全称",
                target: 'why'
              }
            ]
          }
        ]
      }
    }
  }</span>
  &lt;/script&gt;</span></code></pre>
      </div>
    </demo>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: ""
      },
      layer: [
        {
          data: [
            {
              prop: "/form/name",
              data: "商品名称不能为空"
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/name",
              data: "商品的全称",
              target: 'why'
            }
          ]
        }
      ]
    };
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/layer/more.vue